/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import "../css/campaignListcss.css";
import "../css/lineclamp2css.css";
import Swal from "sweetalert2";
import ScrollToTopButton from "./ScrollToTopButton";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { CmsService } from "../services/cmsService";
import Pagination from "@mui/material/Pagination";
import { Stack } from "@mui/material";
import { Modal } from "./ui";
import formErrorPopupInstance from "../utils/formValidation.js";
import { Icon } from "./ui";

function QuickLink(props) {
  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [editIsOpen, setEditIsOpen] = useState(false);
  const [urlName, setUrlName] = useState("");
  const [urlTraName, setUrlTraName] = useState("");
  const [urlSimpName, setUrlSimpName] = useState("");
  const [url, setUrl] = useState("");
  const [Link, setLink] = useState([]);
  const [linkId, setLinkId] = useState("");
  const [selectedValue, setSelectedValue] = useState("10");
  const [preResult, setPreResult] = useState();
  const [nextResult, setNextResult] = useState();
  const [pagination, setPagination] = useState({});
  const [Page, setPage] = useState();
  const [isMobileScreen, setIsMobileScreen] = useState(
    window.innerWidth <= 1250 ? true : false
  );
  const [postData, setPostData] = useState({
    pageableParameter: {
      pageNumber: 0,
      pageSize: 10,
      orderBy: "latestUpdate",
      orderSequence: "desc",
    },
  });

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setPostData({
      pageableParameter: {
        pageNumber: 0,
        pageSize: event.target.value,
        orderBy: "latestUpdate",
        orderSequence: "desc",
      },
    });
  };

  const handlePageChange = (event) => {
    setPage(event);
    setPostData({
      pageableParameter: {
        pageNumber: event - 1,
        pageSize: pagination.pageSize,
        orderBy: "latestUpdate",
        orderSequence: "desc",
      },
    });
  };

  useEffect(() => {
    const savedLanguage = Cookies.get("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  useEffect(() => {
    function handleResize() {
      setIsMobileScreen(window.innerWidth <= 1250);
      // setXsIsMobileScreen(window.screen.width<= 385);
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    // Add this block to update isMobileScreen when the screen size is larger than 1207 pixels
    return () => {
      window.removeEventListener("resize", handleResize);
      setIsMobileScreen(false);
      // setXsIsMobileScreen(false);
    };
  }, []);

  useEffect(() => {
    var cmsService = new CmsService();
    cmsService
      .retrieveLinks(
        postData.pageableParameter.pageNumber,
        postData.pageableParameter.pageSize
      )
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        setLink(data.tcmsQuickLinkEntityList);
        setPagination(data.pagination);

        const pageNumber = parseInt(data.pagination.pageNumber);
        const pageSize = parseInt(data.pagination.pageSize);
        const totalPages = parseInt(data.pagination.totalPages);
        const totalNumberOfRecords = parseInt(
          data.pagination.totalNumberOfRecords
        );
        if (pageNumber === 0) {
          setPreResult(1);
          setNextResult(pageSize);
        } else {
          setPreResult(pageNumber * pageSize + 1);
          setNextResult((pageNumber + 1) * pageSize);
        }

        if (data.pagination.hasNext === "false" && pageNumber !== 0) {
          setPreResult((totalPages - 1) * pageSize + 1);
          setNextResult(totalNumberOfRecords);
        }
      })
      .catch((error) => console.error(error));
  }, [postData, selectedValue, Page]);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openEdit = (data) => {
    setUrlSimpName(data.linkNameCn);
    setUrlTraName(data.linkNameHk);
    setUrlName(data.linkNameEng);
    setUrl(data.url);
    setLinkId(data.linkId);
    setEditIsOpen(true);
  };

  const closeEdit = () => {
    setEditIsOpen(false);
    setUrlSimpName("");
    setUrlTraName("");
    setUrlName("");
    setUrlName("");
    setUrl("");
  };

  const showEditMobile = (data) => {
    setUrlSimpName(data.linkNameCn);
    setUrlTraName(data.linkNameHk);
    setUrlName(data.linkNameEng);
    setUrl(data.url);
    setLinkId(data.linkId);
    setShowEditModal(true);
  };

  const closeEditMobile = () => {
    setShowEditModal(false);
    setUrlSimpName("");
    setUrlTraName("");
    setUrlName("");
    setUrlName("");
    setUrl("");
  };

  const showCreateMobile = () => {
    setShowModal(true);
  };

  const closeCreateMobile = () => {
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("url: " + url);
    const trimmedInput = url.trim();
    console.log("trimmedInput: " + trimmedInput);
    let checkUrl = false;
    if (trimmedInput.startsWith("https://") && trimmedInput.length > 8) {
      checkUrl = true;
    }

    if (urlName === "") {
      formErrorPopupInstance.addError(t("cms.quickLinks.urlnameEng"));
    }

    if (urlSimpName === "") {
      formErrorPopupInstance.addError(t("cms.quickLinks.urlnameCn"));
    }

    if (urlTraName === "") {
      formErrorPopupInstance.addError(t("cms.quickLinks.urlnameHk"));
    }

    if (!checkUrl) {
      formErrorPopupInstance.addError(t("cms.quickLinks.url"));
    }

    formErrorPopupInstance.showErrors();
    if (formErrorPopupInstance.errors.length === 0) {
      var cmsService = new CmsService();
      cmsService
        .retrieveLink(
          0,
          "create",
          urlName.trim(),
          urlSimpName.trim(),
          urlTraName.trim(),
          url
        )
        .then((value) => {
          if (value.status === 200) {
            closeModal();
            Swal.fire({
              icon: "success",
              title: t("cms.quickLinks.created"),
              showConfirmButton: false,
              timer: 1700,
            }).then(function () {
              window.location = "/QuickLinks";
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: t("cms.quickLinks.wrongformat"),
            showConfirmButton: true,
          });
        });
    }
    formErrorPopupInstance.clearErrors();
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    const trimmedInput = url.trim();
    let checkUrl = false;
    if (trimmedInput.startsWith("https://") && trimmedInput.length > 8) {
      checkUrl = true;
    }
    if (urlName === "") {
      formErrorPopupInstance.addError(t("cms.quickLinks.urlnameEng"));
    }

    if (urlSimpName === "") {
      formErrorPopupInstance.addError(t("cms.quickLinks.urlnameCn"));
    }

    if (urlTraName === "") {
      formErrorPopupInstance.addError(t("cms.quickLinks.urlnameHk"));
    }

    if (!checkUrl) {
      formErrorPopupInstance.addError(t("cms.quickLinks.url"));
    }

    formErrorPopupInstance.showErrors();
    if (formErrorPopupInstance.errors.length === 0) {
      var cmsService = new CmsService();
      cmsService
        .retrieveLink(
          linkId,
          "edit",
          urlName.trim(),
          urlSimpName.trim(),
          urlTraName.trim(),
          url
        )
        .then((value) => {
          if (value.status === 200) {
            closeEdit();
            Swal.fire({
              icon: "success",
              title: t("cms.quickLinks.updated"),
              showConfirmButton: false,
              timer: 1700,
            }).then(function () {
              window.location = "/QuickLinks";
            });
          }
          console.log(value.status);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: t("cms.quickLinks.wrongformat"),
            showConfirmButton: true,
          });
        });
      // Handle response
    }
    formErrorPopupInstance.clearErrors();
  };

  const handleDelete = async (linkId) => {
    // Show a confirmation dialog before deleting the URL
    const result = await Swal.fire({
      icon: "warning",
      title: t("common.deleteConfirmText"),
      showCancelButton: true,
      confirmButtonColor: "#dc3545", // set confirm button color to red
      confirmButtonText: t("common.delete"),
      cancelButtonText: t("common.cancel"),
    });

    // Check if the user clicked the delete button
    if (result.isConfirmed) {
      var cmsService = new CmsService();
      cmsService
        .retrieveLink(linkId, "delete", urlName, urlSimpName, urlTraName, url)
        .then((value) => {
          if (value.status === 200) {
            // Reload the page to show the updated list of links
            window.location.reload();
          } else {
            // Handle error
            console.error("Error deleting link");
          }
        });
    }
  };

  return (
    <>
      {isMobileScreen ? (
        <>
          <div className="w-full ">
            <div className="flex">
              <h1 className="text-header font-bold w-3/4 mt-2 text-ft-light">
                {t("cms.quickLinks")}
              </h1>

              <a
                onClick={() => showCreateMobile()}
                className="cursor-pointer w-1/4 text-tableHeader bg-ft-light text-center text-white py-2 px-3 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft">
                {t("common.create")}
              </a>
            </div>
            <div className="mt-2 ">
              <p className="text-content">
                {t("common.showPerPage1")}
                <select
                  id="countries"
                  aria-label="Select page size"
                  className="mx-2 w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                  value={selectedValue}
                  onChange={handleChange}>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                {t("common.showPerPage2")}
              </p>
            </div>

            {showModal ? (
              <>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                  <div className="relative w-5/6 my-6 mx-auto max-w-3xl">
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none p-5">
                      <form onSubmit={handleSubmit}>
                        <div className="w-auto flex-col">
                          <div className="">
                            <label htmlFor="urlName">
                              {t("cms.quickLinks.urlnameEng")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="text"
                              id="urlName"
                              value={urlName}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={(e) => setUrlName(e.target.value)}
                            />
                          </div>
                          <div className="mt-3">
                            <label htmlFor="urlTraName">
                              {t("cms.quickLinks.urlnameHk")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="text"
                              id="urlTraName"
                              value={urlTraName}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={(e) => setUrlTraName(e.target.value)}
                            />
                          </div>
                          <div className="mt-3">
                            <label htmlFor="urlSimpName">
                              {t("cms.quickLinks.urlnameCn")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="text"
                              id="urlSimpName"
                              value={urlSimpName}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={(e) => setUrlSimpName(e.target.value)}
                            />
                          </div>
                          <div className="mt-3">
                            <label htmlFor="url">
                              {t("cms.quickLinks.url")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="text"
                              id="url"
                              value={url || "https://"}
                              className="w-full ring-ft-light focus:border-0"
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                const combinedValue = inputValue.startsWith(
                                  "https://"
                                )
                                  ? inputValue
                                  : `https://${inputValue}`;
                                setUrl(combinedValue);
                              }}
                            />
                          </div>
                        </div>
                        <div className="w-auto max-w-96 flex mt-4">
                          <button
                            type="submit"
                            className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                            {t("common.create")}
                          </button>
                          <button
                            type="button"
                            className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                            onClick={() => closeCreateMobile()}>
                            {t("common.cancel")}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
              </>
            ) : null}

            {showEditModal ? (
              <>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                  <div className="relative w-5/6 my-6 mx-auto max-w-3xl">
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none p-5">
                      <form onSubmit={handleEdit}>
                        <div className="w-auto flex-col">
                          <div className="">
                            <label htmlFor="urlName">
                              {t("cms.quickLinks.urlnameEng")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="text"
                              id="urlName"
                              value={urlName}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={(e) => setUrlName(e.target.value)}
                            />
                          </div>
                          <div className="mt-3">
                            <label htmlFor="urlTraName">
                              {t("cms.quickLinks.urlnameHk")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="text"
                              id="urlTraName"
                              value={urlTraName}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={(e) => setUrlTraName(e.target.value)}
                            />
                          </div>
                          <div className="mt-3">
                            <label htmlFor="urlSimpName">
                              {t("cms.quickLinks.urlnameCn")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="text"
                              id="urlSimpName"
                              value={urlSimpName}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={(e) => setUrlSimpName(e.target.value)}
                            />
                          </div>
                          <div className="mt-3">
                            <label htmlFor="url">
                              {t("cms.quickLinks.url")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="text"
                              id="url"
                              value={url || "https://"}
                              className="w-full ring-ft-light focus:border-0"
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                const combinedValue = inputValue.startsWith(
                                  "https://"
                                )
                                  ? inputValue
                                  : `https://${inputValue}`;
                                setUrl(combinedValue);
                              }}
                            />
                          </div>
                        </div>
                        <div className="w-auto max-w-96 flex mt-4">
                          <button
                            type="submit"
                            className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                            {t("common.save")}
                          </button>
                          <button
                            type="button"
                            className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                            onClick={closeEditMobile}>
                            {t("common.cancel")}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
              </>
            ) : null}
            <div className="flex mt-4">
              <table className=" flex w-full bg-white">
                <thead className="sm:w-1/5 w-2/5 text-white text-mobileLandingContent font-bold">
                  {Link || Link.length !== 0
                    ? Link.map((campaignMobileHead) => {
                        return (
                          <tr
                            className="pl-1 bg-ft-light flex flex-col mb-2 border border-slate-300"
                            key={campaignMobileHead.linkId}>
                            <th className="h-12 ">
                              {t("cms.quickLinks.urlnameEng")}
                            </th>
                            <th className="h-12 ">
                              {t("cms.quickLinks.urlnameHk")}
                            </th>

                            <th className="h-12 ">
                              {t("cms.quickLinks.urlnameCn")}
                            </th>
                            <th className="h-12 ">{t("cms.quickLinks.url")}</th>
                            <th className="h-8 ">{t("common.edit")}</th>
                            <th className="h-8  mb-1">{t("common.delete")}</th>
                          </tr>
                        );
                      })
                    : ""}
                </thead>
                <tbody className="sm:w-4/5 w-3/5 text-mobileLandingContent">
                  {Link.map((campaign) => {
                    return (
                      <tr
                        className="flex flex-col border border-slate-300 mb-2"
                        key={campaign.linkId}>
                        <td className="pl-3 pr-3 h-12 line-clamp-2">
                          {campaign.linkNameEng}
                        </td>
                        <td className="pl-3 pr-3 h-12 line-clamp-2">
                          {campaign.linkNameHk}
                        </td>
                        <td className="pl-3 pr-3 h-12 line-clamp-2">
                          {campaign.linkNameCn}
                        </td>
                        <td className="pl-3 pr-3 h-12 line-clamp-2">
                          {campaign.url}
                        </td>

                        <td className="pl-3 pr-3 h-8">
                          <a onClick={() => showEditMobile(campaign)}>
                            <Icon src="edit" color="primary" />
                          </a>
                        </td>

                        <td className="pl-3 pr-3 h-8 mb-1">
                          <a onClick={() => handleDelete(campaign.linkId)}>
                            <Icon src="delete" color="primary" />
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="flex flex-col items-center">
              <div>
                {pagination.totalNumberOfRecords === 0 ? (
                  <p className="text-sm text-gray-700">
                    {t("common.noRecord")}
                  </p>
                ) : (
                  <p className="text-sm text-gray-700">
                    {t("common.showPage1")}
                    <span className="font-medium"> {preResult}</span>{" "}
                    {t("common.showPage2")}{" "}
                    <span className="font-medium">{nextResult}</span>{" "}
                    {t("common.showPage3")}{" "}
                    <span className="font-medium">
                      {pagination.totalNumberOfRecords}
                    </span>{" "}
                    {t("common.showPage4")}
                  </p>
                )}
              </div>
              {pagination && pagination.totalNumberOfRecords > 0 && (
                <Stack spacing={2}>
                  <Pagination
                    page={parseInt(pagination.pageNumber) + 1}
                    shape={"circular"}
                    count={
                      pagination.totalNumberOfRecords &&
                      pagination.pageSize &&
                      !isNaN(pagination.totalNumberOfRecords) &&
                      !isNaN(pagination.pageSize)
                        ? Math.ceil(
                            pagination.totalNumberOfRecords /
                              pagination.pageSize
                          )
                        : 0
                    }
                    onChange={(e, value) => handlePageChange(value)}
                  />
                </Stack>
              )}
            </div>
            <ScrollToTopButton />
          </div>
        </>
      ) : (
        <div className="w-deflaut px-2">
          <div className="flex justify-content-between align-items-center my-3">
            <p className="text-header text-ft-light font-bold">
              {t("cms.quickLinks")}
            </p>
            <div onClick={openModal}>
              <a
                className={
                  "hover:bg-ft text-tableHeader text-white bg-ft-light rounded px-3 py-2 cursor-pointer"
                }>
                {t("common.create")}
              </a>
            </div>

            <Modal
              open={modalIsOpen}
              onClose={closeModal}
              component="form"
              onSubmit={handleSubmit}>
              <div className="w-categories flex-col">
                <div className="">
                  <label htmlFor="urlName">
                    {t("cms.quickLinks.urlnameEng")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="urlName"
                    value={urlName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setUrlName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="urlTraName">
                    {t("cms.quickLinks.urlnameHk")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="urlTraName"
                    value={urlTraName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setUrlTraName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="urlSimpName">
                    {t("cms.quickLinks.urlnameCn")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="urlSimpName"
                    value={urlSimpName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setUrlSimpName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="url">
                    {t("cms.quickLinks.url")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="url"
                    value={url || "https://"}
                    className="w-full ring-ft-light focus:border-0"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const combinedValue = inputValue.startsWith("https://")
                        ? inputValue
                        : `https://${inputValue}`;
                      setUrl(combinedValue);
                    }}
                  />
                </div>
              </div>
              <div className="w-auto max-w-96 flex mt-4">
                <button
                  type="submit"
                  className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                  {t("common.create")}
                </button>
                <button
                  type="button"
                  className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                  onClick={closeModal}>
                  {t("common.cancel")}
                </button>
              </div>
            </Modal>

            <Modal
              open={editIsOpen}
              onClose={closeEdit}
              component="form"
              onSubmit={handleEdit}>
              <div className="w-categories flex-col">
                <div className="">
                  <label htmlFor="urlName">
                    {t("cms.quickLinks.urlnameEng")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="urlName"
                    value={urlName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setUrlName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="urlTraName">
                    {t("cms.quickLinks.urlnameHk")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="urlTraName"
                    value={urlTraName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setUrlTraName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="urlSimpName">
                    {t("cms.quickLinks.urlnameCn")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="urlSimpName"
                    value={urlSimpName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setUrlSimpName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="url">
                    {t("cms.quickLinks.url")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="url"
                    value={url || "https://"}
                    className="w-full ring-ft-light focus:border-0"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const combinedValue = inputValue.startsWith("https://")
                        ? inputValue
                        : `https://${inputValue}`;
                      setUrl(combinedValue);
                    }}
                  />
                </div>
              </div>
              <div className="w-auto max-w-96 flex mt-4">
                <button
                  type="submit"
                  className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                  {t("common.save")}
                </button>
                <button
                  type="button"
                  className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                  onClick={closeEdit}>
                  {t("common.cancel")}
                </button>
              </div>
            </Modal>
          </div>
          <div className="mr-5">
            <p className="text-content">
              {t("common.showPerPage1")}
              <select
                id="countries"
                aria-label="Select page size"
                className="mx-2 w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                value={selectedValue}
                onChange={handleChange}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              {t("common.showPerPage2")}
            </p>
          </div>
          <div className="p-2 flex align-middle justify-center">
            <div className="">
              <table className="w-full block">
                <thead className="text-tableHeader">
                  <tr className="border border-slate-300 ">
                    <th className="  pl-5 h-8">
                      <div className="inline-block h-6 w-linkRes">
                        {t("cms.quickLinks.urlnameEng")}
                      </div>
                    </th>
                    <th className="  pl-5 h-8">
                      <div className="inline-block h-6 w-linkRes">
                        {t("cms.quickLinks.urlnameHk")}
                      </div>
                    </th>
                    <th className="  pl-5 h-8">
                      <div className="inline-block h-6 w-linkRes">
                        {t("cms.quickLinks.urlnameCn")}
                      </div>
                    </th>
                    <th className="  h-8 ">
                      <div className="inline-block h-6 w-url">
                        {t("cms.quickLinks.url")}
                      </div>
                    </th>
                    <th className=" h-8">
                      <div className="inline-block h-6 w-linkEdit">
                        {t("common.edit")}
                      </div>
                    </th>
                    <th className=" h-8">
                      <div className="inline-block h-6 w-linkEdit mr-3">
                        {t("common.delete")}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="text-left text-content">
                  {Link.map((campaign) => (
                    <tr
                      className="border border-slate-300 h-16"
                      key={campaign.linkId}>
                      <td className="">
                        <div className="w-linkRes line-clamp-2 pl-5 items-center">
                          {campaign.linkNameEng}
                        </div>
                      </td>
                      <td className="">
                        <div className="w-linkRes line-clamp-2 pl-5 items-center">
                          {campaign.linkNameHk}
                        </div>
                      </td>
                      <td className="">
                        <div className="w-linkRes line-clamp-2 pl-5 items-center">
                          {campaign.linkNameCn}
                        </div>
                      </td>
                      <td className="">
                        <div className="w-url line-clamp-2 items-center align-middle">
                          {campaign.url}
                        </div>
                      </td>
                      <td className="cursor-pointer">
                        <a onClick={() => openEdit(campaign)}>
                          <Icon src="edit" color="primary" />
                        </a>
                      </td>
                      <td className="relative cursor-pointer">
                        <a onClick={() => handleDelete(campaign.linkId)}>
                          <Icon src="delete" color="primary" />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex items-center justify-between px-4 py-3 md:px-6">
            <div className="hidden md:flex md:flex-1 md:items-center md:justify-between">
              <div className="text-content">
                {pagination.totalNumberOfRecords === 0 ? (
                  <p className="text-sm text-gray-700">
                    {t("cms.eventCalendar.noEvent")}
                  </p>
                ) : (
                  <p className="text-sm text-gray-700">
                    {t("common.showPage1")}
                    <span className="font-medium"> {preResult}</span>{" "}
                    {t("common.showPage2")}{" "}
                    <span className="font-medium">{nextResult}</span>{" "}
                    {t("common.showPage3")}{" "}
                    <span className="font-medium">
                      {pagination.totalNumberOfRecords}
                    </span>{" "}
                    {t("common.showPage4")}
                  </p>
                )}
              </div>
              <div>
                {pagination && pagination.totalNumberOfRecords > 0 && (
                  <Stack spacing={2}>
                    <Pagination
                      page={parseInt(pagination.pageNumber) + 1}
                      shape={"circular"}
                      count={
                        pagination.totalNumberOfRecords &&
                        pagination.pageSize &&
                        !isNaN(pagination.totalNumberOfRecords) &&
                        !isNaN(pagination.pageSize)
                          ? Math.ceil(
                              pagination.totalNumberOfRecords /
                                pagination.pageSize
                            )
                          : 0
                      }
                      onChange={(e, value) => handlePageChange(value)}
                    />
                  </Stack>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default QuickLink;
